export default {
  middleware_url: "https://ltm-warning.fluid-it.fr",
  cake_url: "https://cake.ltm-warning.fluid-it.fr",
  pwa_url: "https://app.ltm-warning.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: true,
  billingConforamaEnabled: true,
  showLockBillingButton: false,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "30",
  googleMap: {
    api: "AIzaSyBC_3j0i4FLr0PU5C0dEJg0W8peGoLkVZM",
  },
};
